<template>
  <div>
    <div class="app-board mt-3 p-0 d-inline-block">

    </div>


    <div class="mt-3 p-0" style="position: relative;display: flex;justify-content: center; align-items: center;">
      <el-result icon="info" title="Attention" subTitle="Rates Reset" class="p-3 app-board" style="width: 450px">
        <template slot="extra">
          <p style="text-align: justify;padding: 15px">
            This action will reset all system rates testing status, remove testing history, remove reseller rates, and will remove customer rates
          </p>
          <dg-confirm-button
              icon=""
              :loading="false"
              :onConfirm="resetRatesAndTestsAction"
              text="R E S E T"
              :translate="false"
              type="danger mt-1"
              fieldSize="mini"></dg-confirm-button>
        </template>
      </el-result>

      <el-result icon="warning" title="Attention" subTitle="Rates Reset" class="p-3 app-board">
        <template slot="extra">
          <p style="text-align: justify;padding: 15px">
            This Will reset all the selected destination rates to Require Test status
          </p>
          <div style="width: 200px; display: inline-block">
            <dg-select-field
                :field_span="22"
                :label_span="22"
                :options="destinationsDropDownList"
                :translateLabel="false"
                :translateLabels="false"
                @amUpdated="destinationChanged"
                field_mark="required"
                htmlautocomplete="new-password"
                label="Destination"
                labelProperty="label"
                name="destination_id"
                placeholder="Canada / ATI"
                rules="required"
                valueProperty="value"
            ></dg-select-field>
          </div>
          <div style="width: 200px; display: inline-block">
            <dg-select-field
                :field_span="22"
                :label_span="22"
                @amUpdated="divisionChanged"
                :options="divisionsList"
                :translateLabel="false"
                :translateLabels="false"
                field_mark="required"
                label="Division"
                name="division_id"
                rules="required"></dg-select-field>
          </div>
          <div style="width: 200px; display: inline-block">
            <el-button style="position: relative;top: -30px" size="mini" type="primary" @click="resetDestinationRatesAction">Reset</el-button>
          </div>
        </template>
      </el-result>
    </div>
  </div>
</template>

<script>
import {notify} from "@/system-services/notify";

export default {
  data () {
    return {
      destinationsDropDownList: [],
      divisionsList: [],
      selectedDestination: null,
      selectedDivision: null
    }
  },
  beforeMount() {
    this.getDestinationsDropdownlist().then((r) => {
      this.destinationsDropDownList = r
    })

    this.getDivisionsDropDownList().then(r => {
      this.divisionsList = r
    })

  },
  methods: {
    resetRatesAndTestsAction () {
      this.resetRatesAndTests().then( r => {
        notify({
          type: 'success',
          title: 'Success',
          message: '',
          position: 'topRight',
          close: false,
          timeout: 1900,
          animateInside: true,
        });
      }).catch( r => {
        notify({
          type: 'success',
          title: 'Error',
          message: '',
          position: 'topRight',
          close: false,
          timeout: 1900,
          animateInside: true,
        });
      })
    },
    resetDestinationRatesAction() {
      this.resetDestinationRates({
        divisionId: this.selectedDivision,
        destinationId: this.selectedDestination
      }).then( r => {
        notify({
          type: 'success',
          title: 'Success',
          message: '',
          position: 'topRight',
          close: false,
          timeout: 1900,
          animateInside: true,
        });
      }).catch( r => {
        notify({
          type: 'success',
          title: 'Error',
          message: '',
          position: 'topRight',
          close: false,
          timeout: 1900,
          animateInside: true,
        });
      })
    },
    destinationChanged (inputField) {
      let val = inputField.field.field_value
      this.selectedDestination = val
    },
    divisionChanged (inputField) {
      let val = inputField.field.field_value
      this.selectedDivision = val
    },
    ...$mapActions('voip-rate-division-api', {getDivisionsDropDownList: 'getDropDownList'}),
    ...$mapActions('voip-destination-api', {
      getDestinationsDropdownlist: 'getDropDownList',
      resetDestinationRates: 'resetDestinationRates',
      resetRatesAndTests: 'resetRatesAndTests'
    }),
  }
}
</script>
